import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Spin } from 'antd'
import ExternalIcon from '@/assets/icons/ExternalIcon'
import ClientSubmissionMark from '@/components/ModalValidation/MediaMarks/ClientSubmissionMark'
import PromotionalPackageMark from '@/components/ModalValidation/MediaMarks/PromotionalPackageMark'
import { Container, Photo } from './styles'

const ImageHolder = ({ url, ...mediaProps }) => {
  const [isLoading, setIsLoading] = useState(true)
  const route = `/attachment/${url}?type=image`

  useEffect(() => {
    setIsLoading(true)
  }, [url])

  return (
    <Container>
      <img
        src={url}
        alt=""
        hidden
        onLoad={() => setIsLoading(false)}
        onError={() => setIsLoading(false)}
      />
      <Spin spinning={isLoading}>
        <Photo style={{ backgroundImage: `url(${url})` }} />
      </Spin>
      <ClientSubmissionMark url={url} {...mediaProps} />
      <PromotionalPackageMark url={url} {...mediaProps} />

      {route && (
        <Link
          to={route}
          target="_blank"
          rel="noopener noreferrer"
        >
          <ExternalIcon />
        </Link>
      )}
    </Container>
  )
}

export default ImageHolder
